import { Session } from "./session";
// export an existing session instance
export var taxonomy = new Session();
export * from "./labels";
export * from "./session";
export * from "./termgroup";
export * from "./terms";
export * from "./termsets";
export * from "./termstores";
export * from "./types";
export * from "./utilities";
//# sourceMappingURL=taxonomy.js.map